const defaultTimezone = "America/Mexico_City";

const location = {
  placeId: "",
  country: "",
  state: "",
  city: "",
  postalCode: "",
  address: "",
  name: "",
  latitude: 0,
  longitude: 0,
  arrivalDate: "",
  departureDate: "",
  duration: 0,
  distance: 0,
  observation: "",
  isReturn: false,
  type: "",
  timezone: defaultTimezone,
};

const constants = {
  state: {
    USER: "user",
    JWT: "jwt",
    IS_LOGGED_IN: "is_logged_in",
    IS_WHATSAPP_BUBBLE: "is_whatsapp_bubble",
  },
  status: {
    ERROR_MESSAGE: "error_message",
    SUCCESS_MESSAGE: "success_message",
    INFO_MESSAGE: "info_message",
    WARNING_MESSAGE: "warning_message",
  },
  timings: {
    TRIP_CREATION_MIN_DAYS: 4,
  },
  payments: {
    INITIAL_PAYMENT_MIN_DAYS: 3,
    FINAL_PAYMENT_DEADLINE_DAYS: 3,
  },
  UUID: "uuid",
  IS_SIDEBAR_CONTRACTED: "is_sidebar_contracted",
  location,
  defaultTimezone,
};

export default constants;
